import { render } from "./FaxInProcessCases.vue?vue&type=template&id=47bda380&scoped=true"
import script from "./FaxInProcessCases.vue?vue&type=script&lang=js"
export * from "./FaxInProcessCases.vue?vue&type=script&lang=js"

import "./FaxInProcessCases.vue?vue&type=style&index=0&id=47bda380&lang=scss&scoped=true"
import "./FaxInProcessCases.vue?vue&type=style&index=1&id=47bda380&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bda380"],['__file',"src/views/cases/FaxInProcessCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47bda380"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47bda380', __exports__)) {
    console.log('reload')
    api.reload('47bda380', __exports__)
  }
  
  module.hot.accept("./FaxInProcessCases.vue?vue&type=template&id=47bda380&scoped=true", () => {
    console.log('re-render')
    api.rerender('47bda380', render)
  })

}


export default __exports__